import React from 'react'
import ExportMenuItemBase from './ExportMenuItemBase'
import {Area} from 'organization/Event/AreasProvider'
import {useEvent} from 'Event/EventProvider'
import {useOrganization} from 'organization/OrganizationProvider'
import {api} from 'lib/url'
import {useGet} from 'lib/requests'

const ExportAttendeesSummaryMenuItem = React.forwardRef<
  HTMLLIElement,
  {
    area: Area
    setError: (error: string | null) => void
    setSuccess: (success: string | null) => void
  }
>((props, ref) => {
  const {exportLog, processing, errorMessage, successMessage} = useExportLog(
    props.area,
    true,
  )

  return (
    <ExportMenuItemBase
      ref={ref}
      label="Export Summary Log"
      ariaLabel="export summary log"
      area={props.area}
      onExport={exportLog}
      processing={processing}
      errorMessage={errorMessage}
      successMessage={successMessage}
      setError={props.setError}
      setSuccess={props.setSuccess}
    />
  )
})

ExportAttendeesSummaryMenuItem.displayName = 'ExportAttendeesSummaryMenuItem'

export default ExportAttendeesSummaryMenuItem

function useExportLog(area: Area, isSummary?: boolean) {
  const {event} = useEvent()
  const exportMode = isSummary ? 'summary' : 'detail'
  const url = api(
    `/events/${event.id}/areas/${area.id}/attendees/export?exportMode=${exportMode}`,
  )
  const {client} = useOrganization()

  const {send: exportLog, processing, errorMessage, successMessage} = useGet(
    client,
    url,
  )

  return {
    exportLog,
    processing,
    errorMessage,
    successMessage,
  }
}
